import { Card } from "antd";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import dayjs from "dayjs";

const COLORS = {
  income: "#52c41a",
  expenses: "#ff4d4f",
  profit: "#1890ff",
};

function IncomeExpensesChart({ data, loading }) {
  if (!data || data.length === 0) {
    return (
      <Card title="Ingresos vs Gastos" loading={loading}>
        <div className="h-64 flex items-center justify-center text-gray-400">
          No hay datos para mostrar
        </div>
      </Card>
    );
  }

  const formatCurrency = (value) => {
    return `$${value.toLocaleString()}`;
  };

  const formatDate = (dateStr) => {
    return dayjs(dateStr).format("DD/MM");
  };

  return (
    <Card title="Ingresos vs Gastos" loading={loading}>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tickFormatter={formatDate} />
          <YAxis tickFormatter={formatCurrency} />
          <Tooltip
            formatter={(value, name) => [
              formatCurrency(value),
              name === "income" ? "Ingresos" : name === "expenses" ? "Gastos" : "Ganancia",
            ]}
            labelFormatter={(label) => dayjs(label).format("DD/MM/YYYY")}
          />
          <Legend
            formatter={(value) =>
              value === "income" ? "Ingresos" : value === "expenses" ? "Gastos" : "Ganancia"
            }
          />
          <Area
            type="monotone"
            dataKey="income"
            stackId="1"
            stroke={COLORS.income}
            fill={COLORS.income}
            fillOpacity={0.6}
          />
          <Area
            type="monotone"
            dataKey="expenses"
            stackId="2"
            stroke={COLORS.expenses}
            fill={COLORS.expenses}
            fillOpacity={0.6}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Card>
  );
}

export default IncomeExpensesChart;
